import React, { useState } from "react";
import Modal from "react-modal";
import CloseIcon from "@material-ui/icons/Close";
const ModalRemove = (props) => {
  return (
    <div className="testChild">
      <h2>{props.header}</h2>
      <p>{props.content}</p>
      <div className="button-group">
        <button className="btn btn-outline-success px-5 mx-3" type="button" onClick={props.submitClick}>
          بله
        </button>
        <button className="btn btn-danger px-5 mx-3" onClick={props.closeModal} type="button">
          خیر
        </button>
      </div>
    </div>
  );
};

export default ModalRemove;
